<template>
  <div class="app-main-content policy-detail">
    <div class="details-view">
      <div class="main-content" style="overflow-y: unset">
        <div class="section" style="padding:0">
          <el-steps :active="active" simple>
            <el-step :title="$t('Insurance.N1CompleteInsuranceInformation')" icon="1">
              <div slot="title"><span class="index">1</span><span>{{ $t('Insurance.CompleteInsuranceInformation') }}</span></div>
            </el-step>
            <el-step :title="$t('Message.N2Inquiry')" icon="2">
              <div slot="title"><span class="index">2</span><span>{{ $t('Insurance.Inquire') }}</span></div>
            </el-step>
            <el-step :title="$t('Insurance.N3PreviewAndConfirm')" icon="3">
              <div slot="title"><span class="index">3</span><span>{{ $t('Insurance.PreviewAndConfirm') }}</span></div>
            </el-step>
            <el-step :title="$t('Message.N4InsuranceCompletion')" icon="4">
              <div slot="title"><span class="index">4</span><span>{{ $t('Insurance.InsuranceCompleted') }}</span></div>
            </el-step>
          </el-steps>
        </div>
        <el-form inline label-position="left" label-width="200px">
          <div v-show="active === 0 || active === 2">
            <div>
              <div v-show="form.cancelReason !='' && form.cancelReason!=null && viewSource === 'manage'" class="section header">
                {{ $t('Insurance.CancellationReason') }}
              </div>
              <el-form-item v-show="form.cancelReason !='' && form.cancelReason!=null && viewSource === 'manage'" label="" required>
                <span class="input-content">{{ form.cancelReason }}</span>
              </el-form-item>
              <div class="section header">
                {{ $t('Insurance.PolicyHolderInformation') }}
              </div>
              <div class="content">
                <el-form-item :label="$t('Insurance.Insured')" required>
                  <div style="display: flex">
                    <cargo-company-select
                      v-show="!form.sameApplicant"
                      :select-type="selectTypeNames.basic_data_Company"
                      :method-params="{active:true}"
                      :default-value="form.insuredIdx||''"
                      class="input-content"
                      :disabled="disableFlag"
                      @change="p=>{form.insuredIdx = p.value}"
                    />
                    <span v-show="form.sameApplicant" class="input-content" disabled="true"> {{ form.applicantName }}</span>
                    <el-checkbox v-model="form.sameApplicant" style="margin-left: 10px;" :disabled="disableFlag" @change="toAppNameFunc()">{{ $t('Insurance.SameAsPolicyHolder') }}</el-checkbox>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Insurance.PolicyHolder')" required>
                  <span class="input-content">{{ form.applicantName }}</span>
                </el-form-item>
                <el-form-item :label="$t('Insurance.EmailRecipient')" required>
                  <cargo-advance-select
                    filterable
                    allow-create
                    multiple
                    class="input-content"
                    :disabled="disableFlag"
                    :default-multiple-value="multipleEmailArray"
                    :cache="false"
                    tag-name="emailReceivers"
                    tag-value="emailReceivers"
                    :filter-tag-names="['emailReceivers']"
                    :static-options="emailArray"
                    @parentCallBack="getEmailReceviers"
                  />
                </el-form-item>
                <!--<el-form-item label="邮件接收人">
                  <el-input v-model="form.emailReceivers" :disabled="disableFlag" class="input-content" />
                </el-form-item>-->
              </div>
            </div>
            <div>
              <div class="section header">
                {{ $t('Insurance.GoodsInformation') }}
              </div>
              <div class="content">
                <el-form-item :label="$t('Insurance.GoodsCategory')" required>
                  <el-select v-model="form.goodsCategoryCode" style="width: 600px;" filterable :disabled="disableFlag">
                    <el-option
                      v-for="item in goodsCategoryArray"
                      :key="item.code"
                      :label="item.descEN"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('Insurance.GoodsName')" :disabled="disableFlag" required>
                  <el-input v-model="form.goodsName" :disabled="disableFlag" type="textarea" :rows="5" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.MarksAndNumbers')">
                  <el-input v-model="form.shippingMarks" :disabled="disableFlag" type="textarea" :rows="5" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.BillOfLadingNumber')">
                  <el-input v-model="form.blNo" :disabled="disableFlag" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.BillOfLadingDate')">
                  <el-date-picker v-model="form.blDate" :disabled="disableFlag" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.InvoiceNumber')" required>
                  <el-input v-model="form.invoiceNo" :disabled="disableFlag" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.ContractNumber')">
                  <el-input v-model="form.contractNo" :disabled="disableFlag" class="input-content" />
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="section header">
                {{ $t('Insurance.TransportationInformation') }}
              </div>
              <div class="content">
                <el-form-item :label="$t('Insurance.VesselVoyagevehiclePlateNumberflightNumber')" required>
                  <el-input v-model="form.conveyance" :disabled="disableFlag" class="input-content" />
                </el-form-item>
                <el-form-item v-model="form.voyageMode" :disabled="disableFlag" :label="$t('Insurance.TransportationType')" required>
                  <div class="input-content">
                    <el-select v-model="form.voyageMode" filterable :disabled="disableFlag" class="input-content">
                      <el-option :label="$t('Insurance.Domestic')" value="01" />
                      <el-option :label="$t('Insurance.Import')" value="02" />
                      <el-option :label="$t('Insurance.Export')" value="03" />
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Insurance.TransportationMode')" required>
                  <el-radio-group v-model="form.conveyanceType" :disabled="disableFlag" style="width: 700px;">
                    <el-radio label="1">Sea</el-radio>
                    <el-radio label="2">Land</el-radio>
                    <el-radio label="3">Air</el-radio>
                    <el-radio label="4">Parcel Post / Courier</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('Insurance.InlandTransportationTools')">
                  <el-input v-model="form.voyagepreWay" :disabled="disableFlag" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.PlaceOfDepartureport')" required>
                  <div style="display: flex; justify-content: space-between">
                    <cargo-advance-select
                      :disabled="disableFlag"
                      :select-type=" (form.jobLob==='SE' ||form.jobLob==='SI')?selectTypeNames.basic_data_Seaport:selectTypeNames.basic_data_Airport"
                      filterable
                      :default-value="form.fromHaulway"
                      class="input-content"
                      @parentCallBack="p=>{form.fromHaulway=p.value}"
                    />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Insurance.DepartureDate')" required>
                  <el-date-picker v-model="form.inceptionDate" :disabled="disableFlag" :picker-options="pickerOptions" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.TransitPlaceport')">
                  <div style="display: flex; justify-content: space-between">
                    <cargo-advance-select
                      multiple
                      filterable
                      :select-type=" (form.jobLob==='SE' ||form.jobLob==='SI')?selectTypeNames.basic_data_Seaport:selectTypeNames.basic_data_Airport"
                      :default-multiple-value="multipleTransportArray"
                      :disabled="disableFlag"
                      class="input-content"
                      @parentCallBack="getTransPortArray"
                    />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Insurance.Destinationport')" required>
                  <div style="display: flex; justify-content: space-between">
                    <cargo-advance-select
                      :disabled="disableFlag"
                      :select-type=" (form.jobLob==='SE' ||form.jobLob==='SI')?selectTypeNames.basic_data_Seaport:selectTypeNames.basic_data_Airport"
                      filterable
                      class="input-content"
                      :default-value="form.toHaulway"
                      @parentCallBack="p=>{form.toHaulway=p.value}"
                    />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Insurance.InlandStartingPoint')">
                  <el-input v-model="form.departureInland" :disabled="disableFlag" class="input-content" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.TradeTerms')" required>
                  <!--                  <el-input v-model="form.upliftType" :disabled="disableFlag" class="input-content" />-->
                  <div class="input-content">
                    <el-select v-model="form.upliftType" filterable :disabled="disableFlag" class="input-content">
                      <el-option label="EXW" value="UT01" />
                      <el-option label="FCA" value="UT02" />
                      <el-option label="FAS" value="UT03" />
                      <el-option label="FOB" value="UT04" />
                      <el-option label="CFR" value="UT05" />
                      <el-option label="C&F" value="UT06" />
                      <el-option label="CIF" value="UT07" />
                      <el-option label="CPT" value="UT08" />
                      <el-option label="CIP" value="UT09" />
                      <el-option label="DAF" value="UT10" />
                      <el-option label="DAT" value="UT11" />
                      <el-option label="DAP" value="UT12" />
                      <el-option label="DES" value="UT13" />
                      <el-option label="DEQ" value="UT14" />
                      <el-option label="DDU" value="UT15" />
                      <el-option label="DDP" value="UT16" />
                      <el-option label="Invoice Value" value="UT17" />
                    </el-select>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="section header">
                {{ $t('Insurance.InsuranceAmountInformation') }}
              </div>
              <div class="content">
                <el-form-item :label="$t('Insurance.InvoiceAmount')" required>
                  <div style="display: flex">
                    <el-input v-model="form.invoiceAmount" class="input-content" :disabled="disableFlag" type="number" />
                    <el-select v-model="form.currency" style="width: 600px;" :disabled="disableFlag" filterable>
                      <el-option
                        v-for="item in currencyArray"
                        :key="item.code"
                        :label="item.NAME"
                        :value="item.code"
                      />
                    </el-select>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="section header">
                {{ $t('Insurance.InsuranceConditions') }}
              </div>
              <div class="content">
                <el-form-item :label="$t('Insurance.MainInsurance')" required>
                  <el-radio-group v-model="form.mainType" :disabled="disableFlag">
                    <el-radio label="01">{{ $t('Insurance.FreightInsurance') }}</el-radio>
                    <el-radio label="02" disabled="true">{{ $t('Insurance.WPA') }}</el-radio>
                    <el-radio label="03" disabled="true">{{ $t('Insurance.FPA') }}</el-radio>
                    <el-radio label="04" disabled="true">I.C.C.(A)</el-radio>
                    <el-radio label="05" disabled="true">I.C.C.(B)</el-radio>
                    <el-radio label="06" disabled="true">I.C.C.(C)</el-radio>
                    <el-radio label="07" disabled="true">{{ $t('Insurance.AllRiskForRefrigeratedGoods') }}</el-radio>
                    <el-radio label="08" disabled="true">{{ $t('Insurance.RefrigeratedInsurance') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('Message.NumberOfPiecescommissionactual')">
                  <el-input v-model="form.lcConditions" class="input-content" :disabled="disableFlag" />
                </el-form-item>
                <el-form-item :label="$t('Insurance.LetterOfCreditConditionNumber')">
                  <el-input v-model="form.lcNo" class="input-content" :disabled="disableFlag" />
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="section header">
                {{ $t('Insurance.OtherInformation') }}
              </div>
              <div class="content">
                <el-form-item :label="$t('Insurance.ClaimsAgentPoint')" required>
                  <el-select v-model="form.claimagentCode" style="width: 400px;" :disabled="disableFlag">
                    <el-option
                      v-for="item in claimAgentArray"
                      :key="item.code"
                      :label="item.desc"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <div v-show="active === 2">
                  <el-form-item :label="$t('Insurance.Premium')" required>
                    <span class="input-content">{{ form.premium }}</span>
                    <span class="input-content">{{ form.currency }}</span>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div v-show="active === 0">
              <div class="section header" style="background-color: red">
                {{ $t('Insurance.InsuranceInstructions') }}
              </div>
              <div style="width: 1100px; margin: 0 auto">
                <el-checkbox v-model="isAgree" class="el-checkbox__input">
                  <p>{{ $t('Insurance.InsuranceInstructionsTip') }}</p>
                  <p>{{ $t('Insurance.TheInstitutionsWithTechnicalLtd') }}</p>
                </el-checkbox>
              </div>
            </div>
          </div>
          <div v-show="active === 1">
            <div class="section header">
              {{ $t('Insurance.PremiumAmount') }}
            </div>
            <div class="content">
              <el-form-item :label="$t('Insurance.Insured2')">
                <div style="display: flex">
                  <cargo-company-select
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{active:true}"
                    :default-value="form.insuredIdx||''"
                    class="input-content"
                    :disabled="true"
                    @change="p=>{form.insuredIdx = p.value}"
                  />
                </div>
                <!--                <el-input v-model="form.insuredName" class="input-content" :disabled="true" />-->
              </el-form-item>
              <el-form-item :label="$t('Insurance.PolicyHolder')">
                <span class="input-content">{{ $t('Insurance.ShanghaiStorageAndTransportationLtd') }}</span>
              </el-form-item>
              <el-form-item :label="$t('Insurance.InsuranceStartDate')">
                <el-date-picker v-model="form.inceptionDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.EndDateOfInsurance')">
                <el-date-picker v-model="form.terminationDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.DateOfInsurance')">
                <el-date-picker v-model="form.applicationDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.DateOfEntry')">
                <el-date-picker v-model="form.inputDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.MainClause')">
                <el-input v-model="form.mainClauseCode" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.GoodsName2')">
                <el-input v-model="form.goodsName" type="textarea" :rows="5" style="width: 300px" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.InsurancePremium')">
                <el-input v-model="form.premium + ' ' + form.currency" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.InsuranceAmounttotalLimit')">
                <el-input v-model="form.insuranceAmount + ' ' + form.currency" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.FinalRate')">
                <el-input v-model="form.finalRate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.AddProportion')">
                <el-input v-model="form.additionProportion" class="input-content" :disabled="true" />
              </el-form-item>
            </div>
          </div>
          <div v-show="active === 3">
            <div v-if="isSuccess" style="margin-top: 50px;text-align: center;">
              <el-icon class="el-icon-check" style="color: greenyellow;font-size: 45px;" />
              <span style="font-size: 35px;">{{ $t('Insurance.SuccessfullyInsured') }}</span>
            </div>
            <div style="margin-top: 50px;text-align: center;">
              <el-form-item>
                <div style="display: flex;">
                  <span style="font-size: 15px;">{{ $t('Insurance.PolicyNumber') }}</span>
                  <span style="color: blue;text-decoration: underline; cursor: pointer;margin-left: 10px;font-size: 15px;" @click="toManagement()">{{ form.policyNo }}</span>
                </div>
              </el-form-item>
            </div>
            <div class="content">
              <el-form-item :label="$t('Insurance.Insured2')">
                <div style="display: flex">
                  <cargo-company-select
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{active:true}"
                    :default-value="form.insuredIdx||''"
                    class="input-content"
                    :disabled="disableFlag"
                    @change="p=>{form.insuredIdx = p.value}"
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Insurance.PolicyHolder')">
                <span class="input-content"> {{ form.applicantName }}</span>
              </el-form-item>
              <el-form-item :label="$t('Insurance.InsuranceApplicationNumber')">
                <el-input v-model="form.applicationNo" class="input-content" style="color: blue" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.PolicyStatus')">
                <div class="input-content">
                  <el-input v-model="form.policyStatusDescription" class="input-content" style="color: blue" :disabled="true" />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Insurance.InsuranceStartDate')">
                <el-date-picker v-model="form.inceptionDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.EndDateOfInsurance')">
                <el-date-picker v-model="form.terminationDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.DateOfInsurance')">
                <el-date-picker v-model="form.applicationDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.DateOfEntry')">
                <el-date-picker v-model="form.inputDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.ReviewDate')">
                <el-date-picker v-model="form.checkDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.UnderwritingDate')">
                <el-date-picker v-model="form.underwritingDate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.MainClause')">
                <el-input v-model="form.mainClauseCode" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.GoodsName2')">
                <el-input v-model="form.goodsName" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.InsurancePremium')">
                <el-input v-model="form.premium+' '+form.currency" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.InsuranceAmounttotalLimit')">
                <el-input v-model="form.insuranceAmount+' '+form.currency" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.FinalRate')">
                <el-input v-model="form.finalRate" class="input-content" :disabled="true" />
              </el-form-item>
              <el-form-item :label="$t('Insurance.AddProportion')">
                <el-input v-model="form.additionProportion" class="input-content" :disabled="true" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="button">
        <el-button v-if="active === 0" type="primary" @click="temporaryStorage">{{ $t('Insurance.TemporarySave') }}</el-button>
        <el-button v-if="active === 0" type="primary" @click="toPreStep(1,1,false)">{{ $t('Insurance.Inquire') }}</el-button>
        <el-button v-if="active === 1" type="primary" @click="toPreStep(2,0,true)">{{ $t('Insurance.PreviewAndContinue') }}</el-button>
        <el-button v-if="active === 1" type="primary" @click="toPreStep(0,0,false)">{{ $t('Insurance.Back') }}</el-button>
        <el-button v-if="active === 2 && viewSource !='manage'" type="primary" @click="insure()">{{ $t('Insurance.PurchaseInsurance') }}</el-button>
        <el-button v-if="active === 2" type="primary" @click="toPreStep(1,0,true)">{{ $t('Insurance.Back') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Insure } from '@/class/model/booking/Insure'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { getInsureInfoConfig, getSaveInsureConfig, getInsureByUuid, getQueryPriceConfig, getDoInsureConfig, getQueryInvoiceCurrencyConfig, getQueryClaimAgentConfig, getQueryGoodsCategoryConfig, queryEmailReceivers } from '@/api/external/insure'

export default {
  name: 'PolicyDetail',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  data() {
    return {
      active: 0,
      form: new Insure().fillDefaultValue().getData(),
      selectTypeNames: TYPE_NAMES,
      isSuccess: true,
      viewSource: 'cargo',
      isReIssue: '0',
      status: '已提交',
      disableFlag: false,
      goodsCategoryArray: [],
      claimAgentArray: [],
      currencyArray: [],
      emailArray: [],
      multipleEmailArray: [],
      multipleTransportArray: [],
      isAgree: false,
      pickerOptions: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      }
    }
  },
  computed: {
    InsuranceConstants() {
      return InsuranceConstants
    }
  },
  watch: {
  },
  mounted() {
    const params = this.$route.query
    const isReIssue = params.isReIssue
    this.viewSource = params.viewSource
    if (isReIssue === '1') {
      this.form.isReIssue = isReIssue
    }
    if (params) {
      // 老的cargo跳转路径：http://localhost:9528/#/PolicyDetail?sessionId=&jobUuid=$officeId=&viewSource=cargo
      if (params.hasOwnProperty('viewSource') && params.viewSource === 'cargo') { // 从老的cargo点击跳转而来，
        const jobUuid = params.jobUuid
        if (jobUuid) {
          // todo 根据从老的cargo传递来的业务UUID，去后台拼装界面需要得数据
          this.initView(jobUuid, params.type, params.officeId)
        }
      } else { // 从保单管理列表跳转来
        const active = params.active
        if (active) {
          this.active = active
          if (active === 2) {
            this.disableFlag = true
          }
        }
        this.onShow(params.key)
      }
    }
  },
  created() {
  },
  beforeMount() {
    getQueryGoodsCategoryConfig().then(res => {
      this.goodsCategoryArray = res.data
    })
    getQueryClaimAgentConfig().then(res => {
      this.claimAgentArray = res.data
    })
    getQueryInvoiceCurrencyConfig().then(res => {
      this.currencyArray = res.data
    })
    const officeId = this.$route.query.officeId
    queryEmailReceivers({ 'officeId': officeId }).then(res => {
      this.emailArray = res.data
    })
  },
  beforeDestroy() {
  },
  methods: {
    // 渲染界面
    onShow(key = null) {
      if (!key) return
      // todo 根据保单的uuid查询去后台查询对应的详情数据，保证数据是最新的
      //  后端返回的VO
      getInsureByUuid(key, this.form.isReIssue).then(result => {
        this.form = result.data
        this.emailStringToArray()
        this.transportStrToArray()
      })
    },
    // 返回按钮
    toPreStep(active = 0, type, disableFlag) {
      const self = this
      this.disableFlag = disableFlag
      if (this.viewSource === 'manage') {
        this.$router.push({ name: 'Insurance', query: { }})
        return
      }
      if (type === 1) { // 询价
        this.emailArrayToString()
        if (!this.validateForm()) return
        this.transportArrayToString()
        this.loading = getLoading()
        getQueryPriceConfig(this.form).then(result => {
          self.form = result.data
          this.loading.close()
          if (result.data.policyStatusDescription === '1' && result.data.applicationNo != null && result.data.applicationNo !== '') {
            this.active = active
          } else {
            this.$message.warning(result.data.policyStatusDescription)
            return
          }
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.active = active
      }
    },
    // 暂存按钮触发事件
    temporaryStorage() {
      this.emailArrayToString()
      this.transportArrayToString()
      getSaveInsureConfig(this.form).then(res => {
        this.form = res.data
        this.form.isReIssue = '0'
        this.$message.success(this.$t('Insurance.SavedSuccessfully'))
      }
      )
    },
    // 投保按钮触发事件
    insure() {
      const self = this
      this.loading = getLoading()
      getDoInsureConfig(this.form).then(result => {
        self.form = result.data
        self.form.isReIssue = '0'
        this.loading.close()
        if (result.data.policyNo != null && result.data.policyNo !== '') {
          this.active = 3
        } else {
          this.$message.warning(result.data.policyStatusDescription)
          return
        }
      })
    },
    // 初始化加载页面
    initView(uuid, type, officeId) {
      const self = this
      getInsureInfoConfig({ jobUuid: uuid, type: type, officeId: officeId }).then(result => {
        self.form = result.data
        this.emailStringToArray()
        this.transportStrToArray()
      })
    },
    toManagement() {
      this.$router.push({ name: 'Insurance', query: { 'policyNo': this.form.policyNo }})
    },
    toAppNameFunc() {
      if (this.form.sameApplicant) {
        // this.form.insuredIdx = this.form.insuredIdx
        // this.form.insuredEnName = this.form.applicantEnName
      }
    },
    getEmailReceviers(obj) {
      this.multipleEmailArray = obj.value
    },
    getTransPortArray(obj) {
      this.multipleTransportArray = obj.value
    },
    emailArrayToString() {
      this.form.emailReceivers = ''
      for (const item of this.multipleEmailArray) {
        this.form.emailReceivers += item + ';'
      }
      if (this.form.emailReceivers) {
        this.form.emailReceivers = this.form.emailReceivers.substr(0, this.form.emailReceivers.length - 1)
      }
    },
    transportArrayToString() {
      this.form.transportTo = ''
      for (const item of this.multipleTransportArray) {
        this.form.transportTo += item + ';'
      }
      if (this.form.transportTo) {
        this.form.transportTo = this.form.transportTo.substr(0, this.form.transportTo.length - 1)
      }
    },
    emailStringToArray() {
      if (this.form.emailReceivers) {
        this.multipleEmailArray = this.form.emailReceivers.split(';')
      }
    },
    transportStrToArray() {
      if (this.form.transportTo) {
        this.multipleTransportArray = this.form.transportTo.split(';')
      }
    },
    validateForm() {
      if (!this.form.insuredIdx && !this.form.sameApplicant) {
        this.$message.warning(this.$t('Insurance.PleaseNameOfTheCompany'))
        return false
      }
      if (!this.form.emailReceivers) {
        this.$message.warning(this.$t('Insurance.PleaseEmailSeparateMultipleSemicolons'))
        return false
      }
      // const ch = this.form.emailReceivers.charAt(this.form.emailReceivers.length - 1)
      // if (ch === ';') {
      //   this.form.emailReceivers = this.form.emailReceivers.substr(0, this.form.emailReceivers.length - 1)
      // }
      // const regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})(;([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4}))*$/
      // if (!regEmail.test(this.form.emailReceivers)) {
      //   this.$message.warning('邮件接收人格式不对')
      //   return false
      // }
      if (!this.form.goodsCategoryCode) {
        this.$message.warning(this.$t('Insurance.PleaseGeneralCategoryOfGoods'))
        return false
      }
      if (!this.form.goodsName) {
        this.$message.warning(this.$t('Insurance.PleaseTheNameOfGoods'))
        return false
      }
      if (!this.form.invoiceNo) {
        this.$message.warning(this.$t('Insurance.PleaseInTheInvoiceNumber'))
        return false
      }
      if (this.form.shippingMarks.length > 3000) {
        this.$message.warning(this.$t('Insurance.TheShippingMarkCannotCharacters'))
        return false
      }
      if (this.form.invoiceNo.length > 40) {
        this.$message.warning(this.$t('Insurance.TheCannotExceed40Characters'))
        return false
      }
      if (this.form.blNo.length > 100) {
        this.$message.warning(this.$t('Insurance.BillNumberCannotExceedCharacters'))
        return false
      }
      if (this.form.contractNo.length > 100) {
        this.$message.warning(this.$t('Insurance.ContractCannotExceed100Characters'))
        return false
      }
      if (!this.form.conveyance) {
        this.$message.warning(this.$t('Insurance.PleaseVoyageNumberLicenseNumber'))
        return false
      }
      if (!this.form.voyageMode) {
        this.$message.warning(this.$t('Insurance.PleaseEnterTheTransportationType'))
        return false
      }
      if (!this.form.conveyanceType) {
        this.$message.warning(this.$t('Insurance.PleaseEnterTheTransportationMode'))
        return false
      }
      if (!this.form.fromHaulway) {
        this.$message.warning(this.$t('Insurance.PleasePlaceOfDepartureport'))
        return false
      }
      if (!this.form.toHaulway) {
        this.$message.warning(this.$t('Insurance.PleaseEnterTheDestinationport'))
        return false
      }
      if (!this.form.inceptionDate) {
        this.$message.warning(this.$t('Insurance.PleaseEnterTheDepartureDate'))
        return false
      }
      // if (moment(moment(this.form.inceptionDate).format('YYYY-MM-DD')).isBefore(moment().format('YYYY-MM-DD'))) {
      //   this.$message.warning('起保日期不可早于当前日期')
      //   return false
      // }
      if (!this.form.upliftType) {
        this.$message.warning(this.$t('Insurance.PleaseEnterTheTradeTerms'))
        return false
      }
      if (!this.form.invoiceAmount) {
        this.$message.warning(this.$t('Insurance.PleaseEnterTheInvoiceAmount'))
        return false
      }
      if (!this.form.currency) {
        this.$message.warning(this.$t('Insurance.PleaseEnterTheInvoiceCurrency'))
        return false
      }
      if (!this.form.claimagentCode) {
        this.$message.warning(this.$t('Insurance.PleaseTheClaimAgencyPoint'))
        return false
      }
      if (!this.isAgree) {
        this.$message.warning(this.$t('Insurance.PleaseAgreeToTheNotice'))
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.policy-detail{
  .header{
    font-size: 24px;
  }
  .content{
    padding-top: 30px;
    width: 1100px;
    margin: 0 auto
  }
  .input-content{
    width: 300px;
    min-width: 300px;
    margin-right: 30px;
  }
  .el-form-item__label{
    font-size: 15px !important;
  }
  .el-checkbox__input{
    vertical-align: top;
    margin-top: 14px;
  }
  .button {
    display:flex;
    justify-content: center;
  }
  .el-steps {
    &.el-steps--simple {
      padding:0!important;
      border-radius: 0;
      .el-step{
        width: 25%;
        .el-step__head {
          width: 0;
          padding: 0;
          &.is-process+.el-step__main{
            background-color: #FF9933;
          }
        }
        .el-step__main{
          padding: 10px 0;
          .el-step__title {
            flex-grow: 1;
            text-align: center;
            max-width: unset;
            color:#fff!important;
            span{
              display: inline-block;
              font-size: 14px;
              height: 30px;
              line-height: 30px;
              vertical-align: bottom;
              &.index{
                margin-right: 5px;
                font-size: 26px!important;
              }
            }
          }
          .el-step__arrow{
            flex-grow: unset;
            color:#fff!important;
            width: 20px;
            &::before,&::after{
              background-color: #fff;
            }
          }
        }
      }
    }
    background-color: #86C7F5;
  }
}
</style>
